/**
 * Concatena os campos de endereço do formulário em uma string única.
 */
export function buildAddress(data: Record<string, unknown>): string {
  return [data.street, data.streetNumber, data.neighborhood, data.city, data.zipCode]
    .filter(Boolean)
    .join(', ');
}
